// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Signature_container__Zih8o {
  width: 500px;
}

.Signature_title__7tTIA {
  width: 100%;
  margin-top: 28px;
  font-weight: 400;
  font-size: 28px;
  line-height: 48px;
  text-align: left;
}

.Signature_form__Vy0s0 {
  display: flex;
  flex-direction: column;
}

.Signature_inputs__iLKiD {
  margin-bottom: 100px;
}

.Signature_check__dcNwi {
  margin-bottom: 45px;
}
.Signature_check-title__fn2\\+F {
  margin-bottom: 16px;
  font-weight: 500;
  font-size: 20px;
  line-height: 36px;
  color: #00007a;
}
.Signature_check-methods__sfWPO {
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 104px;
}
.Signature_check-method__fSXf3 {
  width: 244px;
  padding: 20px 12px;
  border-radius: 8px;
  border: 1px solid #d8d8ff;
  text-align: center;
  background: #fff;
  cursor: pointer;
}
.Signature_check-method__fSXf3.Signature_selected__mdEeR {
  background: #4343ff;
}
.Signature_check-method__fSXf3.Signature_selected__mdEeR p {
  color: #fff;
}
.Signature_check-method__fSXf3 p {
  font-size: 16px;
  line-height: 28px;
}

.Signature_checkbox-label__mfV6c {
  font-weight: 300;
  font-size: 16px;
  line-height: 28px;
  color: #00007a;
}

.Signature_link__svpQn {
  display: contents;
}
.Signature_link__svpQn a,
.Signature_link__svpQn a:visited {
  text-decoration: underline;
  color: #00007a;
}

.Signature_button__PmHB\\+ {
  align-self: center;
  width: 200px;
  padding: 0 24px;
}

.Signature_signature-iframe__lEj6l {
  width: 100%;
  height: 650px;
}
.Signature_signature-iframe__lEj6l.Signature_inactive__ikI4V {
  display: none;
}
.Signature_signature-iframe__lEj6l iframe {
  width: 100%;
  height: 100%;
}

@media screen and (max-width: 600px) {
  .Signature_container__Zih8o {
    width: fit-content;
  }
  #Signature_signature-iframe__lEj6l {
    width: 100%;
  }
  .Signature_check__dcNwi {
    margin: 0 0 20px;
  }
  .Signature_check-methods__sfWPO {
    justify-content: space-between;
  }
  .Signature_check-method__fSXf3 {
    width: 49%;
  }
  .Signature_inputs__iLKiD {
    margin-bottom: 32px;
  }
  .Signature_button__PmHB\\+ {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Subscription/Signature/Signature.module.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAGA;EACE,YAAA;AAIF;;AADA;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AAIF;;AADA;EACE,aAAA;EACA,sBAAA;AAIF;;AADA;EACE,oBAAA;AAIF;;AADA;EACE,mBAAA;AAIF;AAFE;EACE,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cC1BO;AD8BX;AADE;EACE,aAAA;EACA,6BAAA;EACA,mBAAA;EACA,aAAA;AAGJ;AAAE;EACE,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AAEJ;AAAI;EACE,mBClDK;ADoDX;AAAM;EACE,WAAA;AAER;AAEI;EACE,eAAA;EACA,iBAAA;AAAN;;AAME;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cCjEO;AD8DX;;AAOA;EACE,iBAAA;AAJF;AAME;;EAEE,0BAAA;EACA,cC3EO;ADuEX;;AAQA;EACE,kBAAA;EACA,YAAA;EACA,eAAA;AALF;;AAQA;EACE,WAAA;EACA,aAAA;AALF;AAOE;EACE,aAAA;AALJ;AAQE;EACE,WAAA;EACA,YAAA;AANJ;;AAUA;EACE;IACE,kBAAA;EAPF;EAUA;IACE,WAAA;EARF;EAWA;IACE,gBAAA;EATF;EAWE;IACE,8BAAA;EATJ;EAYE;IACE,UAAA;EAVJ;EAcA;IACE,mBAAA;EAZF;EAeA;IACE,WAAA;EAbF;AACF","sourcesContent":["@use 'styles/sizes.scss';\n@use 'styles/colors.scss';\n\n.container {\n  width: 500px;\n}\n\n.title {\n  width: 100%;\n  margin-top: 28px;\n  font-weight: 400;\n  font-size: 28px;\n  line-height: 48px;\n  text-align: left;\n}\n\n.form {\n  display: flex;\n  flex-direction: column;\n}\n\n.inputs {\n  margin-bottom: 100px;\n}\n\n.check {\n  margin-bottom: 45px;\n\n  &-title {\n    margin-bottom: 16px;\n    font-weight: 500;\n    font-size: 20px;\n    line-height: 36px;\n    color: colors.$primary8;\n  }\n\n  &-methods {\n    display: flex;\n    justify-content: space-around;\n    align-items: center;\n    height: 104px;\n  }\n\n  &-method {\n    width: 244px;\n    padding: 20px 12px;\n    border-radius: 8px;\n    border: 1px solid colors.$primary2;\n    text-align: center;\n    background: #fff;\n    cursor: pointer;\n\n    &.selected {\n      background: colors.$primary4;\n\n      p {\n        color: #fff;\n      }\n    }\n\n    p {\n      font-size: 16px;\n      line-height: 28px;\n    }\n  }\n}\n\n.checkbox {\n  &-label {\n    font-weight: 300;\n    font-size: 16px;\n    line-height: 28px;\n    color: colors.$primary8;\n  }\n}\n\n.link {\n  display: contents;\n\n  a,\n  a:visited {\n    text-decoration: underline;\n    color: colors.$primary8;\n  }\n}\n\n.button {\n  align-self: center;\n  width: 200px;\n  padding: 0 24px;\n}\n\n.signature-iframe {\n  width: 100%;\n  height: 650px;\n\n  &.inactive {\n    display: none;\n  }\n\n  iframe {\n    width: 100%;\n    height: 100%;\n  }\n}\n\n@media screen and (max-width: sizes.$breakpoint-sm) {\n  .container {\n    width: fit-content;\n  }\n\n  #signature-iframe {\n    width: 100%;\n  }\n\n  .check {\n    margin: 0 0 20px;\n\n    &-methods {\n      justify-content: space-between;\n    }\n\n    &-method {\n      width: 49%;\n    }\n  }\n\n  .inputs {\n    margin-bottom: 32px;\n  }\n\n  .button {\n    width: 100%;\n  }\n}\n","$primary1: #f5f5ff;\n$primary2: #d8d8ff;\n$primary3: #8686ff;\n$primary4: #4343ff;\n$primary5: #1414ff;\n$primary6: #0000c9;\n$primary7: #000093;\n$primary8: #00007a;\n$primary9: #000054;\n$primary10: #00003a;\n$primary11: #000078;\n$blueLogo: #000093;\n\n$neutral1: #fcfcfd;\n$neutral2: #f9f9fa;\n$neutral4: #e0e0e3;\n$neutral8: #838390;\n\n$success1: #f4fced;\n$success5: #58b441;\n$success6: #126f0e;\n\n$attention1: #fef9f0;\n$attention3: #fbd298;\n$attention5: #e78d3d;\n$attention7: #b94402;\n\n$danger1: #fdf1ed;\n$danger2: #f9d9cf;\n$danger3: #f4ada1;\n$danger5: #bd454a;\n$danger6: #911727;\n$danger7: #7c1028;\n\n\n$colabelNeutralLight: #F9F9FA;\n$colabelNeutralMid: #C3C3C9;\n$colabelNeutralDark: #121217;\n\n:export {\n    colabelNeutralLight: $colabelNeutralLight;\n    colabelNeutralMid: $colabelNeutralMid;\n    colabelNeutralDark: $colabelNeutralDark;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colabelNeutralLight": `#F9F9FA`,
	"colabelNeutralMid": `#C3C3C9`,
	"colabelNeutralDark": `#121217`,
	"container": `Signature_container__Zih8o`,
	"title": `Signature_title__7tTIA`,
	"form": `Signature_form__Vy0s0`,
	"inputs": `Signature_inputs__iLKiD`,
	"check": `Signature_check__dcNwi`,
	"check-title": `Signature_check-title__fn2+F`,
	"check-methods": `Signature_check-methods__sfWPO`,
	"check-method": `Signature_check-method__fSXf3`,
	"selected": `Signature_selected__mdEeR`,
	"checkbox-label": `Signature_checkbox-label__mfV6c`,
	"link": `Signature_link__svpQn`,
	"button": `Signature_button__PmHB+`,
	"signature-iframe": `Signature_signature-iframe__lEj6l`,
	"inactive": `Signature_inactive__ikI4V`
};
export default ___CSS_LOADER_EXPORT___;
